import { CSSProperties } from '@material-ui/styles';
import { Theme } from './styles';
import { hexToRgbA } from 'common-react';

export const flexCenter = () => {
    return {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
};

export const borderRadius = (topLeft:number, ...args:Array<number>) => {
  const borderRadiusValue = Array.from(args).length > 0 ? `${topLeft}px ${Array.from(args).join("px ") + 'px'}` : `${topLeft}px`;
  return {
    borderRadius: borderRadiusValue,
  }
};

type FocusOffset = -2 | 0 | 2;

export const focusStyle = (theme: Theme, offset: FocusOffset = 2) => {
  return {
    outline: `2px solid ${theme.color.greys[80]}`,
    outlineOffset: offset,
  }
};

export const focusStyleByBoxShadow = (theme: Theme, offset: FocusOffset = 2) => ({
  boxShadow: `0 0 0 ${2 + offset}px ${theme.color.greys[80]}`,
  outline: 'none',
});

export const screenOnlyStyle = () => ({
  position: 'absolute',
  size: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0
});

type BsType = `bs${number}`;

export const fieldBoxShadow = (theme: Theme): Record<BsType, string> => {
  return {
    bs1: `0 0 0 1px ${hexToRgbA(theme.color.greys[80])}`,
    bs2: `inset 0 0 0 2px ${theme.color.oranges[50]}`,
    bs3: `0px 5px 5px -3px ${hexToRgbA(
      theme.color.greys[80],
      0.14,
    )},0px 8px 10px 1px ${hexToRgbA(
      theme.color.greys[80],
      0.14,
    )},0px 3px 14px 2px ${hexToRgbA(theme.color.greys[80], 0.12)}`,
    bs4: `0px 1px 5px 0px ${hexToRgbA(
      theme.color.greys[80],
      0.2,
    )}, 0px 3px 1px -2px ${hexToRgbA(
      theme.color.greys[80],
      0.12,
    )}, 0px 2px 2px 0px   ${hexToRgbA(theme.color.greys[80], 0.14)}`,
  };
};

export const borderGenerator = (theme: Theme, borderWidth: string = '2px') => {
  return {
    borderMainSolid2: `${borderWidth} solid ${theme.color.violets[50]}`,
  }
}

export const scrollbarStyleMixin = ({
  size = 10,
  trackColor = 'transparent',
  thumbColor = '',
  thumbHoverColor = '',
  borderRadius = 8,
  theme,
}: {
  size?: number;
  trackColor?: string;
  thumbColor?: string;
  thumbHoverColor?: string;
  borderRadius?: number;
  theme?: Theme;
}): CSSProperties => {

  return {
    // 🔹 Firefox
    scrollbarWidth: 'inherit',
    scrollbarColor: `${thumbColor} ${trackColor}`,

    // 🔹 Webkit
    '&::-webkit-scrollbar': {
      width: size,
    },

    '&::-webkit-scrollbar-track': {
      background: trackColor,
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: thumbColor || theme?.color.greys[30],
      borderRadius,
      border: '2px solid transparent',
      backgroundClip: 'content-box',
    },

    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: thumbHoverColor || theme?.color.greys[40],
    },
  };
};

export const layeredBackgroundMixin = ({
  baseColor,
  overlayColor,
  overlayOpacity,
}: {
  baseColor: string;
  overlayColor: string;
  overlayOpacity: number;
}) => ({
  backgroundColor: baseColor,
  backgroundImage: `linear-gradient(
    ${hexToRgbA(overlayColor, overlayOpacity)},
    ${hexToRgbA(overlayColor, overlayOpacity)}
  )`,
});